import CtaWhats from "./CtaWhats";

const HERO_IMG = "/lovable-uploads/f2d82c03-7324-4443-98db-f57b5c6ab20b.png";

const Hero = () => (
  <section className="relative flex min-h-svh flex-col items-center justify-center overflow-hidden px-6 py-16 text-center">
    {/* foto de fundo com overlay escuro + ken burns lento */}
    <div className="absolute inset-0" aria-hidden="true">
      <img
        src={HERO_IMG}
        alt=""
        className="e21-kenburns h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black" />
    </div>

    <span className="absolute left-6 top-6 z-10 font-mono text-[10px] uppercase tracking-[0.3em] text-white/30">
      media kit · duducrespo
    </span>

    <div className="relative z-10 flex flex-col items-center">
      <span className="e21-word font-mono text-[11px] uppercase tracking-[0.3em] text-white/40">
        media kit 2025
      </span>

      <h1
        className="e21-word mt-5 text-[2.75rem] font-extrabold leading-[1.02] tracking-[-0.03em] sm:text-6xl md:text-7xl"
        style={{ animationDelay: "120ms" }}
      >
        conteúdo que <span className="e21-serif text-green-400">move</span> gente.
      </h1>

      <p
        className="e21-word mt-8 max-w-md text-base leading-relaxed text-white/60 sm:text-lg"
        style={{ animationDelay: "320ms" }}
      >
        quase 40 mil no instagram, 15 mil no tiktok em 3 semanas e uma comunidade
        que lotou com 1.700 pessoas na primeira semana. tudo orgânico. essa é a
        audiência que a tua marca alcança comigo.
      </p>

      <div
        className="e21-word mt-10 flex flex-col items-center gap-4 sm:flex-row"
        style={{ animationDelay: "480ms" }}
      >
        <button
          type="button"
          onClick={() =>
            document.getElementById("metrics")?.scrollIntoView({ behavior: "smooth" })
          }
          className="inline-flex items-center justify-center rounded-full border border-white/20 bg-white/5 px-8 py-4 text-base font-bold tracking-[-0.02em] text-white transition-colors hover:bg-white/10"
        >
          ver os números
        </button>
        <CtaWhats />
      </div>
    </div>
  </section>
);

export default Hero;
